"use strict";

exports.__esModule = true;
exports.SelectDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useItemSelection = require("./useItemSelection");
var _Dropdown = require("./Dropdown/Dropdown");
var _selectDropdownTypes = require("./Types/selectDropdownTypes");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable import/prefer-default-export */
/* eslint react/forbid-prop-types: 0 */

const SelectDropdown = props => {
  const {
    isOpen,
    items,
    selected,
    active,
    setActiveMenu,
    onChange,
    cssModifier,
    isLeaveClose,
    isHoverOpen,
    isItemsUnselectable,
    id,
    setIsOpen,
    openMenu,
    setOpenMenu,
    isPersistSelectEvent // Eveytime the item is selected, return the current selection data
  } = props;
  const [open, setOpen] = (0, _react.useState)(isOpen);

  // handles item selection concerns
  const {
    selection,
    onItemSelection
  } = (0, _useItemSelection.useItemSelection)(selected);

  // handles item click events
  const onChangeHandler = item => {
    const selectionData = onItemSelection(item, isItemsUnselectable, isPersistSelectEvent);

    // close dropdown
    setOpen(false);

    // callback to notify of change
    if (selectionData) {
      onChange(selectionData);
    }
  };

  // onMouseLeave
  const onDropdownLeave = isLeaveClose ? () => {
    setOpen(false);
  } : undefined;

  // When a menu is opened, set isOpen to true
  // (this keeps track of whether any menu is currently open)
  // allowing other menus to be opened just by hovering
  (0, _react.useEffect)(() => {
    if (open) {
      setIsOpen(true);
      setOpenMenu(id);
    }
  }, [open]);

  // If a menu becomes open, close any other open menus
  (0, _react.useEffect)(() => {
    if (openMenu !== id) {
      setOpen(false);
    }
  }, [openMenu]);

  // When a menu becomes active, close any open menus
  (0, _react.useEffect)(() => {
    setOpenMenu(undefined);
  }, [active]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Dropdown, {
    types: props.types,
    selection: selection,
    onDropdownLeave: onDropdownLeave,
    cssModifier: cssModifier,
    open: open,
    setOpen: setOpen,
    items: items,
    onChange: onChangeHandler,
    active: active,
    setActiveMenu: setActiveMenu,
    id: id,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    isHoverOpen: isHoverOpen,
    setOpenMenu: setOpenMenu
  });
};
exports.SelectDropdown = SelectDropdown;
SelectDropdown.defaultProps = {
  types: _selectDropdownTypes.selectDropdownTypes,
  isOpen: false,
  isLeaveClose: true,
  isHoverOpen: false,
  isItemsUnselectable: true,
  onChange: (selectedId, item) => {},
  selected: undefined,
  setIsOpen: () => {},
  setOpenMenu: () => {},
  isPersistSelectEvent: false
};